module.exports = __webpack_public_path__ + "static/media/header.980c04d3.png";